import { format, parseISO, isValid } from 'date-fns';
import { ja } from 'date-fns/locale';

export const formatDate = (date: string | Date, formatStr: string = 'yyyy年MM月dd日'): string => {
  if (!date) return '';
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) return '';
    return format(dateObj, formatStr, { locale: ja });
}


export const formatDateTime = (date: string | Date): string => {
  return formatDate(date, 'yyyy年MM月dd日 HH:mm');
};

export const formatTime = (date: string | Date): string => {
  return formatDate(date, 'HH:mm');
};

export const formatDateForInput = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

/**
 * UI 表示用の日付フォーマッタ (YYYY/MM/DD、月日は2桁ゼロ埋め)。
 * - 不正値・空値は "" を返す
 * - 入力は ISO 文字列 / Date / "YYYY-MM-DD" 系を許容
 * - フォーム値・URL・API 通信用の YYYY-MM-DD はこの関数を通さずそのまま使うこと。
 *   これは「人間が読む表示」専用。
 */
export const formatDateSlash = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) return '';
  return format(dateObj, 'yyyy/MM/dd');
};